import { render, staticRenderFns } from "./anomaly.vue?vue&type=template&id=78763afa&scoped=true&"
import script from "./anomaly.vue?vue&type=script&lang=js&"
export * from "./anomaly.vue?vue&type=script&lang=js&"
import style0 from "./anomaly.vue?vue&type=style&index=0&id=78763afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78763afa",
  null
  
)

export default component.exports